export const getClassNames = (obj: {[keyName: string]: boolean}): string => {
  try {
    const classNamesArr: string[] = [];
    const objArr = Object.entries(obj);
    for (let i = 0; i < objArr.length; i++) {
      const t = objArr[i];
      !!t[1] && classNamesArr.push(t[0]);
    }
    return classNamesArr.join(' ');
  } catch (error) {
    console.error(error);
    return '';
  }
}
